import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type CreateVehicleCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateVehicleCargoItemInput;
}>;

export type CreateVehicleCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoCreateVehicleCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'CreateVehicleCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<GraphQLTypes.CargoContainerType, 'id'>)
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<GraphQLTypes.CargoLooseCargoType, 'id'>)
        | ({ __typename?: 'CargoVehicleType' } & Pick<GraphQLTypes.CargoVehicleType, 'id'>)
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateVehicleCargoItemDocument = gql`
  mutation createVehicleCargoItem($input: CreateVehicleCargoItemInput!) {
    cargoCreateVehicleCargoItem(input: $input) {
      cargoItem {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
